import { Component, input } from '@angular/core';
import { InputControl } from '../../../controls/setup-wizard/input-control/input-control';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'app-text-field',
	imports: [InputControl],
	templateUrl: './text-field.html',
	styleUrl: './text-field.scss',
})
export class TextField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	minLength = input<number | null>(null);
	type = input<string>('text');
	formGroup = input.required<FormGroup>();
}
